/* eslint-disable max-lines-per-function */

import React from 'react';
import { Table } from 'semantic-ui-react';
import {
    Header, renderPrice, Title, filterObject, colors
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const CountryClubTowers = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>
            <Title data={Object.values(filterObject(data, '255-'))} title='Country Club Towers'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header >
                    <Table.Row>
                        <Header colSpan='100' content='CCT Side ( 255- | Bldg 4 )' />
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.cct.unit.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.cct.type.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.cct.type2.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.cct.sqft.map(i => <Header content={i} />)}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan='100' content='North Floors'/>
                    </Table.Row>
                    {['6', '5', '4', '3', '2'].map(floor => (
                        <Table.Row>
                            {HEADERS.bldg4.cct.unit.map((unit, i) => {
                                const isFloorCell = i === 0;
                                const content = isFloorCell ? floor : renderPrice(data[`255-${floor}${unit}`], matrixType);
                                const style = isFloorCell ? {} : { backgroundColor: colors[data[`255-${floor}${unit}`].status] };

                                return <Table.Cell
                                    style={style}
                                    textAlign='center'
                                    content={content}
                                />;
                            })}
                        </Table.Row>
                    ))}
                    <Table.Row>
                        {['', '', '', '1BR', '1BR', '', '', '', '', '', '', '1BR', '1BR', ''].map(i => <Table.Cell textAlign='center' content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.cct.unit.map((unit, i) => {
                            const isFloorCell = i === 0;
                            const content = isFloorCell ? '1' : renderPrice(data[`255-1${unit}`], matrixType);
                            const style = isFloorCell ? {} : { backgroundColor: colors[data[`255-1${unit}`].status] };

                            return <Table.Cell style={style} textAlign='center' content={content}/>;
                        })}
                    </Table.Row>
                    <Table.Row>
                        {['', '', '', 'I-6', 'I-6s', '', '', '', '', '', '', 'I-6s', 'I-6', ''].map(i => <Table.Cell textAlign='center' content={i} />)}
                    </Table.Row>
                </Table.Body>
            </Table>

            <Table celled compact>
                <Table.Header >
                    <Table.Row>
                        <Header colSpan='100' content='Courtyard Side ( 255- | Bldg 4 )' />
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.courtyard.unit.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.courtyard.type.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.courtyard.type2.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg4.courtyard.sqft.map(i => <Header content={i} />)}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan='100' content='South Floors'/>
                    </Table.Row>
                    {['6', '5', '4', '3', '2', '1'].map(floor => (
                        <Table.Row>
                            {HEADERS.bldg4.courtyard.unit.map((unit, i) => {
                                const isFloorCell = i === 0;
                                const content = isFloorCell ? floor : renderPrice(data[`255-${floor}${unit}`], matrixType);
                                const style = isFloorCell ? {} : { backgroundColor: colors[data[`255-${floor}${unit}`].status] };

                                return <Table.Cell textAlign='center' content={content} style={style}/>;
                            })}
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />
            <Title data={Object.values(filterObject(data, '245-'))} title='Country Club Towers'/>
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header >
                    <Table.Row>
                        <Header colSpan='100' content='Courtyard Side ( 245- | Bldg 5 )' />
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.courtyard.unit.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.courtyard.type.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.courtyard.type2.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.courtyard.sqft.map(i => <Header content={i} />)}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan='100' content='North Floors'/>
                    </Table.Row>
                    {['6', '5', '4', '3', '2', '1'].map(floor => (
                        <Table.Row>
                            {HEADERS.bldg5.courtyard.unit.map((unit, i) => {
                                const isFloorCell = i === 0;
                                const content = isFloorCell ? floor : renderPrice(data[`245-${floor}${unit}`], matrixType);
                                const style = isFloorCell ? {} : { backgroundColor: colors[data[`245-${floor}${unit}`].status] };

                                return <Table.Cell textAlign='center' style={style} content={content}/>;
                            })}
                        </Table.Row>
                    ))}
                </Table.Body>
            </Table>

            <Table celled compact>
                <Table.Header >
                    <Table.Row>
                        <Header colSpan='100' content='South Side ( 245- | Bldg 5 )' />
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.southside.unit.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.southside.type.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.southside.type2.map(i => <Header content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.southside.sqft.map(i => <Header content={i} />)}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell colSpan='100' content='South Floors'/>
                    </Table.Row>
                    {['6', '5', '4', '3', '2'].map(floor => (
                        <Table.Row>
                            {HEADERS.bldg5.southside.unit.map((unit, i) => {
                                const isFloorCell = i === 0;
                                const content = isFloorCell ? floor : renderPrice(data[`245-${floor}${unit}`], matrixType);
                                const style = isFloorCell ? {} : { backgroundColor: colors[data[`245-${floor}${unit}`].status] };

                                return <Table.Cell textAlign='center' style={style} content={content}/>;
                            })}
                        </Table.Row>
                    ))}
                    <Table.Row>
                        {['', '', '', '1BR', '1BR', '', '', '', '', '', '', '1BR', '1BR'].map(i => <Table.Cell textAlign='center' content={i} />)}
                    </Table.Row>
                    <Table.Row>
                        {HEADERS.bldg5.southside.unit.map((unit, i) => {
                            const isFloorCell = i === 0;
                            const content = isFloorCell ? '1' : renderPrice(data[`245-1${unit}`], matrixType);
                            const style = isFloorCell ? {} : { backgroundColor: colors[data[`245-1${unit}`].status] };

                            return <Table.Cell textAlign='center' style={style} content={content}/>;
                        })}
                    </Table.Row>
                    <Table.Row>
                        {['', '', '', 'I-6', 'I-6s', '', '', '', '', '', '', 'I-6s', 'I-6'].map(i => <Table.Cell textAlign='center' content={i} />)}
                    </Table.Row>
                </Table.Body>
            </Table>


            <Table celled compact>
                <Table.Header >
                    <Table.Row>
                        <Header colSpan='100' content='Townhouses' />
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell content='TH-001' />
                        <Table.Cell content='TH-002' />
                        <Table.Cell content='TH-003' />
                        <Table.Cell content='TH-004' />
                        <Table.Cell content='TH-005' />
                    </Table.Row>

                </Table.Header>
                <Table.Body>
                    <Table.Row>
                        {['1', '2', '3', '4', '5'].map(num => (
                            <Table.Cell
                                content={renderPrice(data[`TH-00${num}`], matrixType)}
                                style={{ backgroundColor: colors[data[`TH-00${num}`].status] }}
                            />
                        ))}
                    </Table.Row>
                </Table.Body>
            </Table>

        </div>
    );


};


const HEADERS = {
    bldg4: {
        cct: {
            unit: ['Unit', '28', '26', '24', '22', '20', '18', '16', '02', '04', '06', '08', '10', '12', '14'],
            type: ['Type', '2BR', '2BR', '2BR', '2BR', '2BR', '1BR', '1BR', '1BR', '1BR', '2BR', '2BR', '2BR', '2BR', '2BR'],
            type2: ['', 'I-4', 'I-2', 'I-2A', 'I-3', 'I-2', 'I-1A', 'I-1A', 'I-1A', 'I-1A', 'I-2', 'I-3', 'I-2A', 'I-2', 'I-4'],
            sqft: ['sq ft', '972', '1017', '995', '907', '1017', '774', '774', '774', '774', '1017', '907', '995', '1017', '972']
        },
        courtyard: {
            unit: ['Unit', '29', '27', '25', '23', '21', '19', '17', '15', '01', '03', '05', '07', '09', '11', '13'],
            type: ['Type', '2BR', 	'2BR', 	'2BR', 	'2BR', 	'1BR', 	'1BR', 	'1BR', 	'1BR', 	'2BR', 	'1BR', 	'1BR', '2BR', '2BR', '2BR', '2BR'],
            type2: ['', 'I-4', 'I-5', 'I-5', 'I-5', 'I-1', 'I-1', 'I-1', 'I-1', 'I-5', 'I-1', 'I-1', 'I-5', 'I-5', 'I-5', 'I-4'],
            sqft: ['sq ft', '972', '1008', '1008', '1008', '774', '774', '774', '774', '1008', '774', '774', '1008', '1008', '1008', '972']
        }
    },
    bldg5: {
        courtyard: {
            unit: ['Unit', '26', '24', '22', '20', '18', '16', '14', '12', '02', '04', '06', '08', '10'],
            type: ['Type', '2BR', '2BR', '2BR', '2BR', '1BR', '1BR', '1BR', '1BR', '2BR', '1BR', '2BR', '2BR', '2BR'],
            type2: ['', 'I-4', 'I-5', 'I-5', 'I-5', 'I-1', 'I-1', 'I-1', 'I-1', 'I-5', 'I-1', 'I-5', 'I-5', 'I-4'],
            sqft: ['sq ft', '972', '1008', '1008', '1008', '774', '774', '774', '774', '1008', '774', '1008', '1008', '972']
        },
        southside: {
            unit: ['Unit', '25', '23', '21', '19', '17', '15', '13', '01', '03', '05', '07', '09', '11'],
            type: ['Type', '2BR', '2BR', '2BR', '2BR', '2BR', '1BR', '1BR', '1BR', '1BR', '2BR', '2BR', '2BR', '2BR'],
            type2: ['', 'I-4', 'I-2', 'I-2A', 'I-3', 'I-2', 'I-1A', 'I-1A', 'I-1A', 'I-1A', 'I-2', 'I-3', 'I-5', 'I-4'],
            sqft: ['sq ft', '972', '1017', '995', '907', '1017', '774', '774', '774', '774', '1017', '907', '1008', '972']
        }
    }
};

export default CountryClubTowers;
